import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderRoutingModule } from './loader-routing.module';
import { LoaderComponent } from './loader.component';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@NgModule({
  declarations: [
    LoaderComponent
  ],
  imports: [
    CommonModule,
    LoaderRoutingModule,
    MatProgressSpinnerModule,
    CustomFlexLayoutModule
  ],exports:[
    LoaderComponent
  ]
})
export class LoaderModule { }
